import { useEffect, useState } from "react"
import ContactBar from "../ContactBar"
import ThemeToggle from "../ThemeToggle"
import { SITE_INFO } from "../../constants"
import "../../styles/glitch.css"
import { cn } from "../../lib/utils"

export default function StickyHeader() {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const heroSection = document.getElementById("landing")

    if (heroSection && "IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setIsVisible(!entry.isIntersecting || entry.intersectionRatio < 0.6)
        },
        { threshold: 0.6 }
      )

      observer.observe(heroSection)
      return () => observer.disconnect()
    }

    const handleScrollFallback = () => {
      setIsVisible(window.scrollY > window.innerHeight * 0.3)
    }

    window.addEventListener("scroll", handleScrollFallback)
    handleScrollFallback()

    return () => window.removeEventListener("scroll", handleScrollFallback)
  }, [])

  return (
    <header
      className={cn(
        "fixed left-0 right-0 top-0 z-50 flex h-[var(--header-height)] items-center justify-center px-4 opacity-0 pointer-events-none -translate-y-2 transition-[background-color,box-shadow,opacity,transform] duration-200 motion-reduce:transition-none",
        isVisible &&
          "pointer-events-auto translate-y-0 bg-surface opacity-100 shadow-[0_2px_12px_rgba(0,0,0,0.4)]"
      )}
    >
      <div className="flex w-full max-w-[var(--max-width)] items-center">
        <div className="flex flex-1 items-center">
          <h1
            className="glitchHeading glitchHeadingSticky hidden whitespace-nowrap text-xl font-bold sm:block"
            data-text={SITE_INFO.name}
          >
            {SITE_INFO.name}
          </h1>
        </div>
        <div className="flex flex-1 items-center justify-center">
          <ContactBar />
        </div>
        <div className="flex flex-1 items-center justify-end">
          <ThemeToggle className="h-9 w-9" />
        </div>
      </div>
    </header>
  )
}
